import translationEN from "../locales/en.json";
import {
  ADDRESS_STATUS,
  LOOKUP_CATEGORY,
  PAYMENT_ENTITY_TYPE,
  PAYMENT_METHOD,
  PAYMENT_STATUS,
  USER_STATUS,
} from "./AppEnumerations";
export const MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED =
  "unknown_error_occurred_try_again";
export const MESSAGE_LOCAL_SUCCESS = "success";
export const DEFAULT_STATUS_CODE_UNKNOWN_ERROR = 500;
export const DEFAULT_STATUS_CODE_SUCCESS = 200;
export const DEFAULT_STATUS_CODE_CONSENT = 422;
export const DEFAULT_STATUS_CODE_UNAUTHORIZED = 401;
export const DEFAULT_DUPLICATE_LOOKUP_KEY = "duplicate_lookup_data_value";
export const FILE_NAME_MAX_LENGTH = 20;
export const MESSAGE_UNKNOWN_ERROR_OCCURRED = "UNKNOWN ERROR OCCURRED";
export const MESSAGE_UNKNOWN_ERROR_DECRYPTION = "Decryption failed";
export const MESSAGE_TOKEN_EXPIRED = "TokenExpiredError";
export const DEFAULT_STATUS_CODE_NO_CONTENT = " ";
export const TOKEN_EXPIRED_KEY = "authorization_token_expired";
export const TOKEN_INVALID_ACCESS_TOKEN = "authorization_invalid_token";
export const EVENT_KEY_SESSION_LIMIT = "authorization_session_limit_exceeded";
export const DEFAULT_STATUS_CODE_CONFLICT = 409;
export const LOGIN_SESSION_LIMIT_REACHED = "login_session_limit_reached";
export const LOGIN_SESSION_TICKET_EXPIRED = "login_session_ticket_expired";
export const LANGUAGE_LIST = [
  {
    country_code: null,
    code: "en",
    name: "English",
    local_name: "English",
    path: translationEN,
  },
];

export const ORDER_BY = {
  desc: "DESC",
  asc: "ASC",
};

export const DEFAULT_CREATED_BY = "System Administrator";
export const DEFAULT_MODIFIED_BY = "System Administrator";

export const MONTH_SHORT_NAME = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const USER_STATUS_LABEL = {
  [USER_STATUS.Admin]: "Admin",
  [USER_STATUS.User]: "User",
  [USER_STATUS.Trainer]: "Trainer",
};

export const USER_STATUS_OPTION = [
  {
    value: USER_STATUS.Admin,
    label: USER_STATUS_LABEL[USER_STATUS.Admin],
  },
  {
    value: USER_STATUS.User,
    label: USER_STATUS_LABEL[USER_STATUS.User],
  },
  {
    value: USER_STATUS.Trainer,
    label: USER_STATUS_LABEL[USER_STATUS.Trainer],
  },
];

export const CURRENCY_SIGN = "₹";

export const LOOKUP_CATEGORY_LABEL = {
  [LOOKUP_CATEGORY.FirmType]: "firm_type",
  [LOOKUP_CATEGORY.MeasurementUnit]: "measurement_unit",
  [LOOKUP_CATEGORY.Gender]: "gender",
  [LOOKUP_CATEGORY.DateFormat]: "date_format",
  [LOOKUP_CATEGORY.TimeFormat]: "time_format",
  [LOOKUP_CATEGORY.ExpenseHead]: "expense_head",
};

export const LOOKUP_CATEGORY_OPTION = [
  {
    data_value: LOOKUP_CATEGORY.FirmType,
    display_value: LOOKUP_CATEGORY_LABEL[LOOKUP_CATEGORY.FirmType],
  },
  {
    data_value: LOOKUP_CATEGORY.MeasurementUnit,
    display_value: LOOKUP_CATEGORY_LABEL[LOOKUP_CATEGORY.MeasurementUnit],
  },
  {
    data_value: LOOKUP_CATEGORY.Gender,
    display_value: LOOKUP_CATEGORY_LABEL[LOOKUP_CATEGORY.Gender],
  },
  {
    data_value: LOOKUP_CATEGORY.DateFormat,
    display_value: LOOKUP_CATEGORY_LABEL[LOOKUP_CATEGORY.DateFormat],
  },
  {
    data_value: LOOKUP_CATEGORY.TimeFormat,
    display_value: LOOKUP_CATEGORY_LABEL[LOOKUP_CATEGORY.TimeFormat],
  },
  {
    data_value: LOOKUP_CATEGORY.ExpenseHead,
    display_value: LOOKUP_CATEGORY_LABEL[LOOKUP_CATEGORY.ExpenseHead],
  },
];

export const PAGINATION_PER_PAGE_ROWS = {
  Twenty: 20,
  Ten: 10,
};

export const ADDRESS_STATUS_LABEL = {
  [ADDRESS_STATUS.Pending]: "Pending",
  [ADDRESS_STATUS.Verified]: "Verified",
  [ADDRESS_STATUS.Rejected]: "Rejected",
};

export const ADDRESS_STATUS_OPTION = [
  {
    data_value: ADDRESS_STATUS.Pending,
    display_value: ADDRESS_STATUS_LABEL[ADDRESS_STATUS.Pending],
  },
  {
    data_value: ADDRESS_STATUS.Verified,
    display_value: ADDRESS_STATUS_LABEL[ADDRESS_STATUS.Verified],
  },
  {
    data_value: ADDRESS_STATUS.Rejected,
    display_value: ADDRESS_STATUS_LABEL[ADDRESS_STATUS.Rejected],
  },
];

export const PAYMENT_ENTITY_TYPE_LABEL = {
  [PAYMENT_ENTITY_TYPE.SubscriptionPackage]: "SP",
};

export const PAYMENT_ENTITY_TYPE_OPTION = [
  {
    data_value: PAYMENT_ENTITY_TYPE.SubscriptionPackage,
    display_value:
      PAYMENT_ENTITY_TYPE_LABEL[PAYMENT_ENTITY_TYPE.SubscriptionPackage],
  },
];

export const PAYMENT_ENTITY_STATUS_LABEL = {
  [PAYMENT_STATUS.Succeeded]: "Succeeded",
  [PAYMENT_STATUS.Initiated]: "Initiated",
  [PAYMENT_STATUS.Failed]: "Failed",
};

export const PAYMENT_ENTITY_TYPE_STATUS_OPTION = [
  {
    data_value: PAYMENT_STATUS.Succeeded,
    display_value: PAYMENT_ENTITY_STATUS_LABEL[PAYMENT_STATUS.Succeeded],
  },
  {
    data_value: PAYMENT_STATUS.Initiated,
    display_value: PAYMENT_ENTITY_STATUS_LABEL[PAYMENT_STATUS.Initiated],
  },
  {
    data_value: PAYMENT_STATUS.Failed,
    display_value: PAYMENT_ENTITY_STATUS_LABEL[PAYMENT_STATUS.Failed],
  },
];

export const PAYMENT_METHOD_LABEL = {
  [PAYMENT_METHOD.Cash]: "Cash",
  [PAYMENT_METHOD.Card]: "Card",
  [PAYMENT_METHOD.Cheque]: "Cheque",
};

export const PAYMENT_METHOD_STATUS_OPTION = [
  {
    data_value: PAYMENT_METHOD.Cash,
    display_value: PAYMENT_METHOD_LABEL[PAYMENT_METHOD.Cash],
  },
  {
    data_value: PAYMENT_METHOD.Card,
    display_value: PAYMENT_METHOD_LABEL[PAYMENT_METHOD.Card],
  },
  {
    data_value: PAYMENT_METHOD.Cheque,
    display_value: PAYMENT_METHOD_LABEL[PAYMENT_METHOD.Cheque],
  },
];
